// Entry point for customer portal

// Import Turbo (Hotwire)
import "@hotwired/turbo-rails"

// Import Stimulus
import { Application } from "@hotwired/stimulus"
import DatepickerController from "./controllers/datepicker_controller"
import DealerMarketingModalController from "./controllers/customer_portal/dealer_marketing_modal_controller"
import PaymentFormController from "./controllers/customer_portal/payment_form_controller"
import PaymentAmountSelectorController from "./controllers/customer_portal/payment_amount_selector_controller"
import UserTypeToggleController from "./controllers/customer_portal/user_type_toggle_controller"
import TokenCleanerController from "./controllers/customer_portal/token_cleaner_controller"

const application = Application.start()
application.register("datepicker", DatepickerController)
application.register("customer-portal--dealer-marketing-modal", DealerMarketingModalController)
application.register("customer-portal--payment-form", PaymentFormController)
application.register("customer-portal--payment-amount-selector", PaymentAmountSelectorController)
application.register("customer-portal--user-type-toggle", UserTypeToggleController)
application.register("customer-portal--token-cleaner", TokenCleanerController)

// Import Bootstrap (bundle includes Popper for both tooltips and popovers)
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle";

// Initialize Bootstrap components on page load and Turbo navigation
function initializeBootstrapComponents() {
  // initialize bootstrap tooltips
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

  // initialize bootstrap popovers
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
  [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))
}

// Run on initial page load
document.addEventListener('DOMContentLoaded', initializeBootstrapComponents)

// Run on Turbo navigation
document.addEventListener('turbo:load', initializeBootstrapComponents)

// Run after Turbo renders a new page
document.addEventListener('turbo:render', initializeBootstrapComponents)

// Custom Turbo Stream actions for Bootstrap modal control
Turbo.StreamActions.show_modal = function () {
  const el = document.getElementById(this.getAttribute("target"))
  if (el) new bootstrap.Modal(el).show()
}

Turbo.StreamActions.hide_modal = function () {
  const el = document.getElementById(this.getAttribute("target"))
  if (el) bootstrap.Modal.getInstance(el)?.hide()
}
